package ui.screens

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Section
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import ui.components.Navbar
import ui.components.Footer as SiteFooter

@Composable
fun AboutUsScreen(
    onBack: () -> Unit,
    onNavigateToTerms: () -> Unit,
    onNavigateToPrivacy: () -> Unit
) {
    Div(attrs = {
        classes("min-h-screen", "bg-gray-50")
    }) {
        Navbar(onNavigateHome = onBack)

        // --- HERO SECTION ---
        Section(attrs = {
            classes("pt-40", "pb-20", "bg-gray-50", "relative", "overflow-hidden")
        }) {
            // Decoración de fondo
            Div(attrs = {
                classes("absolute", "top-0", "right-0", "w-1/3", "h-full", "bg-medical-primary/5", "skew-x-[-12deg]", "translate-x-1/2")
            })

            Div(attrs = { classes("max-w-7xl", "mx-auto", "px-6", "relative", "z-10") }) {
                Div(attrs = { classes("flex", "flex-col", "md:flex-row", "items-center", "gap-16") }) {
                    Div(attrs = { classes("w-full", "md:w-2/3") }) {
                        Span(attrs = { 
                            classes("text-medical-tertiary", "font-black", "uppercase", "tracking-widest", "text-sm") 
                        }) { Text("Innovación Médica") }
                        H1(attrs = { classes("text-4xl", "md:text-6xl", "font-bold", "text-gray-900", "mt-4", "mb-6") }) {
                            Text("Facilitando la labor médica con ")
                            Span(attrs = { style { property("color", "#80CBC4") } }) { Text("tecnología de primera") }
                        }
                        P(attrs = { classes("text-xl", "text-gray-600", "leading-relaxed") }) {
                            Text("Dr. Recipe es una solución diseñada para potenciar la labor del profesional de la salud. Actualmente optimizada para dispositivos Android, nuestra plataforma utiliza estándares modernos para garantizar eficiencia y seguridad en cada consulta.")
                        }
                    }
                    
                    // Placeholder para foto en Hero
                    Div(attrs = { 
                        classes("w-full", "md:w-1/3", "flex", "justify-center", "items-center") 
                    }) {
                        Div(attrs = {
                            classes("w-64", "h-64", "bg-medical-primary/5", "rounded-[3rem]", "border-4", "border-white", "shadow-xl", "flex", "items-center", "justify-center", "relative")
                        }) {
                            Span(attrs = { classes("material-symbols-outlined", "text-medical-primary/20", "text-[120px]") }) { Text("person") }
                            Div(attrs = {
                                classes("absolute", "-bottom-4", "-right-4", "bg-white", "p-4", "rounded-2xl", "shadow-lg")
                            }) {
                                Span(attrs = { classes("material-symbols-outlined", "text-medical-primary") }) { Text("add_a_photo") }
                            }
                        }
                    }
                }
            }
        }

        // --- SECCIÓN: HISTORIA DE DR. RECIPE ---
        Section(attrs = { classes("py-20", "bg-white", "relative", "overflow-hidden") }) {
            Div(attrs = { classes("max-w-7xl", "mx-auto", "px-6") }) {
                Div(attrs = { classes("flex", "flex-col", "md:flex-row", "gap-16", "items-center") }) {
                    Div(attrs = { classes("w-full", "md:w-1/2") }) {
                        Span(attrs = { classes("text-medical-primary", "font-bold", "uppercase", "text-xs", "tracking-widest") }) { Text("Desde el origen") }
                        H2(attrs = { classes("text-3xl", "md:text-4xl", "font-bold", "text-gray-900", "mt-4", "mb-8") }) { Text("La Historia de Dr. Recipe") }
                        Div(attrs = { classes("space-y-6", "text-gray-600", "text-lg", "leading-relaxed") }) {
                            P {
                                Text("Nuestra historia comenzó con la visión de crear un puente sólido entre la medicina tradicional y la innovación tecnológica. Dr. Recipe nace de la necesidad real detectada en el día a día de las consultas médicas en Venezuela.")
                            }
                            P {
                                Text("[Espacio reservado para el texto detallado de la historia: Aquí profundizaremos en los retos, la inspiración y los hitos que marcaron el desarrollo de la aplicación hasta su lanzamiento en producción].")
                            }
                        }
                    }
                    // Logo con aviso de protección
                    Div(attrs = { classes("w-full", "md:w-1/2", "flex", "flex-col", "items-center", "gap-4") }) {
                        Div(attrs = { classes("w-full", "aspect-video", "bg-white/50", "backdrop-blur-sm", "rounded-[2.5rem]", "shadow-inner", "border", "border-gray-200", "flex", "items-center", "justify-center", "relative") }) {
                            Img(src = "img_historia_logo.webp", attrs = { classes("h-32", "w-auto", "rounded-3xl") })
                        }
                        Span(attrs = { classes("text-[10px]", "text-gray-400", "uppercase", "tracking-widest", "font-bold") }) { 
                            Text("© 2020 Dr. Recipe - Todos los derechos reservados")
                        }
                    }
                }
            }
        }

        // --- MISIÓN Y VISIÓN ---
        Section(attrs = { classes("py-24") }) {
            Div(attrs = { classes("max-w-7xl", "mx-auto", "px-6") }) {
                Div(attrs = { classes("grid", "grid-cols-1", "md:grid-cols-2", "gap-12") }) {
                    // Misión
                    Div(attrs = { classes("bg-white", "p-12", "rounded-[3rem]", "shadow-xl", "border", "border-gray-100") }) {
                        Div(attrs = { classes("w-16", "h-16", "bg-medical-primary/10", "rounded-2xl", "flex", "items-center", "justify-center", "text-medical-primary", "mb-8") }) {
                            Span(attrs = { classes("material-symbols-outlined", "text-4xl") }) { Text("rocket_launch") }
                        }
                        H2(attrs = { classes("text-3xl", "font-bold", "text-gray-900", "mb-6") }) { Text("Nuestra Misión") }
                        P(attrs = { classes("text-gray-600", "text-lg", "leading-relaxed") }) {
                            Text("Empoderar a los médicos con herramientas digitales intuitivas y seguras que eliminen la carga administrativa, permitiéndoles enfocarse en lo que realmente importa: la salud de las personas.")
                        }
                    }

                    // Visión
                    Div(attrs = { classes("bg-medical-primary", "p-12", "rounded-[3rem]", "shadow-xl", "text-white") }) {
                        Div(attrs = { classes("w-16", "h-16", "bg-white/20", "rounded-2xl", "flex", "items-center", "justify-center", "text-white", "mb-8") }) {
                            Span(attrs = { classes("material-symbols-outlined", "text-4xl") }) { Text("visibility") }
                        }
                        H2(attrs = { classes("text-3xl", "font-bold", "mb-6") }) { Text("Nuestra Visión") }
                        P(attrs = { classes("text-white/80", "text-lg", "leading-relaxed") }) {
                            Text("Convertirnos en el estándar de gestión médica digital en Venezuela, siendo la plataforma de confianza que une la seguridad legal con la simplicidad operativa en cada consulta a nivel nacional.")
                        }
                    }
                }
            }
        }

        // --- LOS FUNDADORES ---
        Section(attrs = { classes("py-24", "bg-white") }) {
            Div(attrs = { classes("max-w-7xl", "mx-auto", "px-6") }) {
                Div(attrs = { classes("text-center", "mb-20") }) {
                    Span(attrs = { classes("text-medical-tertiary", "font-black", "uppercase", "tracking-widest", "text-sm") }) { Text("El Corazón del Proyecto") }
                    H2(attrs = { classes("text-3xl", "md:text-5xl", "font-bold", "text-gray-900", "mt-4") }) { Text("Detrás de Dr. Recipe") }
                    P(attrs = { classes("text-gray-500", "mt-8", "max-w-2xl", "mx-auto", "text-lg", "mb-16") }) {
                        Text("Somos un equipo impulsado por la pasión de mejorar la medicina a través de la tecnología y la experiencia clínica real.")
                    }
                }

                // Foto Principal (Placeholder para ustedes dos)
                Div(attrs = { 
                    classes("relative", "max-w-4xl", "mx-auto", "mb-20", "aspect-[16/9]", "bg-gray-100", "rounded-[3rem]", "overflow-hidden", "group", "border-4", "border-white", "shadow-2xl") 
                }) {
                    Div(attrs = { classes("absolute", "inset-0", "flex", "flex-col", "items-center", "justify-center", "text-gray-300") }) {
                        Span(attrs = { classes("material-symbols-outlined", "text-8xl", "mb-4") }) { Text("groups") }
                        Text("Próximamente: Foto del Equipo Fundador")
                    }
                }

                // Cards Individuales
                Div(attrs = { classes("grid", "grid-cols-1", "md:grid-cols-2", "gap-12", "max-w-5xl", "mx-auto") }) {
                    FounderCard(
                        name = "Alex Castillo", 
                        role = "Ingeniero de Software & Fundador", 
                        description = "Especialista en Kotlin Multiplatform con 6 años de experiencia desarrollando productos móviles de alto impacto. Responsable de la arquitectura y robustez técnica de la plataforma.",
                        icon = "code"
                    )
                    FounderCard(
                        name = "Astrid de Castillo", 
                        role = "Médico General & Co-fundadora", 
                        description = "Con 8 años de experiencia en hospitales y telemedicina, aporta la visión clínica esencial para que Dr. Recipe responda a las necesidades reales del consultorio moderno.",
                        icon = "medical_services"
                    )
                }
            }
        }

        // --- FOOTER CTA (Google Play Badge) ---
        Section(attrs = { classes("py-24", "bg-medical-primary") }) {
            Div(attrs = { classes("max-w-4xl", "mx-auto", "px-6", "text-center") }) {
                H2(attrs = { classes("text-3xl", "md:text-5xl", "font-bold", "text-white", "mb-8", "leading-tight") }) {
                    Text("Únete a la evolución de la medicina digital")
                }
                
                Div(attrs = { 
                    classes("flex", "flex-col", "sm:flex-row", "items-center", "justify-center", "gap-8") 
                }) {
                    A(href = "https://play.google.com/store/apps/details?id=com.artisancode.drrecipe", attrs = {
                        attr("target", "_blank")
                        classes("inline-block", "transition-all", "hover:scale-105")
                    }) {
                        Img(src = "disponible_play.svg", attrs = {
                            classes("h-20", "w-auto") 
                            attr("alt", "Disponible en Google Play")
                        })
                    }

                    Div(attrs = { 
                        classes("flex", "items-center", "gap-3", "text-white/90", "text-sm", "font-medium") 
                    }) {
                        Span(attrs = { classes("material-symbols-outlined") }) { Text("verified") }
                        Text("15 días de prueba gratuita")
                    }
                }
            }
        }

        // --- FOOTER ---
        SiteFooter(
            onNavigateToTerms = onNavigateToTerms,
            onNavigateToPrivacy = onNavigateToPrivacy
        )
    }
}

@Composable
private fun FounderCard(name: String, role: String, description: String, icon: String) {
    Div(attrs = { classes("p-10", "bg-gray-50", "rounded-[2.5rem]", "border", "border-gray-100", "relative", "overflow-hidden") }) {
        // Icono de fondo más visible y mejor posicionado
        Span(attrs = { 
            classes("material-symbols-outlined", "absolute", "-right-2", "-bottom-2", "text-9xl", "text-medical-primary/10", "rotate-12")
        }) { Text(icon) }

        Div(attrs = { classes("flex", "items-center", "gap-4", "mb-6") }) {
            Div(attrs = { classes("w-14", "h-14", "bg-medical-primary", "rounded-2xl", "flex", "items-center", "justify-center", "text-white") }) {
                Span(attrs = { classes("material-symbols-outlined", "text-2xl") }) { Text("person") }
            }
            Div {
                H3(attrs = { classes("text-2xl", "font-bold", "text-gray-900") }) { Text(name) }
                Span(attrs = { classes("text-medical-primary", "font-bold", "text-[11px]", "uppercase", "tracking-widest") }) { Text(role) }
            }
        }
        P(attrs = { classes("text-gray-500", "leading-relaxed", "text-lg", "relative", "z-10") }) { Text(description) }
    }
}
